import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M6.497 1c-.794.001-.781.033-.532 1.031L7.59 7h-4.5L1.872 5.219C1.732 5.009 1.749 5 1.528 5h-.219c-.428 0-.281.438-.281.438L1.309 8l-.281 2.563s-.14.437.25.437h.25c.211 0 .204-.009.344-.219L3.09 9h4.5l-1.625 4.938C5.704 14.983 5.701 15 6.497 15c.432 0 .433-.012.718-.5L10.903 9h3.094c.554 0 1-.446 1-1s-.446-1-1-1h-3.094L7.215 1.5c-.266-.457-.283-.498-.656-.5z" fill="#474747" /></svg>;
}

export default SvgComponent;